import { Controller } from 'stimulus'
import Hammer from 'hammerjs'
import Rails from '@rails/ujs'
import { gsap, ScrollToPlugin } from "gsap/all";
gsap.registerPlugin(ScrollToPlugin);

export default class extends Controller {
  static targets = [ 'menu', 'section' ]

  show(event) {
    for(let menu of this.menuTargets) {
      menu.classList.add('blue')
      menu.classList.remove('black')

    }
    for(let section of this.sectionTargets) {
      section.classList.add('dn')

    }
    event.currentTarget.classList.remove('blue')
    event.currentTarget.classList.add('black')
    this.sectionTargets[this.menuTargets.indexOf(event.currentTarget)].classList.remove('dn')
  }
}
